/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { useSubscription } from 'store/auth/auth-store';
import apiInputService from 'services/apiInputService';
import { IGetActivityItemsConfig, IProfiles } from './@types';

const fetchActivityItemConfigProfile = async (
  profile: IProfiles,
): Promise<IGetActivityItemsConfig> => {
  const { data } = await apiInputService.get(
    `/activitiesItemsConfig/allActivities/${profile}`,
  );

  return data;
};

export const useActivityItemConfigProfile = (
  profile: IProfiles,
  options?: any,
) => {
  const { subscription } = useSubscription();

  return useQuery<IGetActivityItemsConfig>(
    ['activity-item-config-profile', subscription?.subscriptionId, profile],
    () => fetchActivityItemConfigProfile(profile),
    {
      ...options,
      enabled: !!subscription?.subscriptionId,
      keepPreviousData: true,
      cacheTime: 0.15 * 60 * 1000,
    },
  );
};
